export const DEFAULT_AVATAR: string = "https://ionicframework.com/docs/img/demos/avatar.svg";